import { site } from "../content";

export default function Logo({ as: Tag = "a", href = "#home", className = "" }) {
  return (
    <Tag className={`logo ${className}`.trim()} href={Tag === "a" ? href : undefined}>
      <img src="/finitygrowth-logo.svg" alt={site.name} />
    </Tag>
  );
}
